module.exports = __webpack_public_path__ + "01390f05d3c7ef1d54378b11bff70097.svg";